import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { IModalProps, Modal } from './Modal'

const modal: IModalProps = observable({
  show: false,
  children: null,
  onHide: () => {}
})

export const showModal = (props: IModalProps) => {
  Object.assign(modal, props)
  modal.show = true
}

export const hideModal = () => {
  modal.show = false
}

const ModalServiceRenderer = () => {
  return (
    <Modal
      onHide={() => {
        modal.show = false
      }}
      newDesign
      {...modal}
    />
  )
}

export default observer(ModalServiceRenderer)
